export default __webpack_public_path__ + "3917983235ed8bd7ca0922e15546a756.svg";